import { isBehaviourDisabled, type ParticipantBehaviour } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaEye } from 'react-icons/fa';
import { showModal } from '../../../components/generic/Modal';
import { ParticipantBehaviourActionMenu } from './ParticipantBehaviourActionMenu';
import { ParticipantBehaviourDataSummary } from './ParticipantBehaviourDataSummary';
import { ParticipantBehaviourRecordingCreateButton } from './ParticipantBehaviourRecordingCreateButton';
import { ParticipantBehaviourRecordingsModal } from './ParticipantBehaviourRecordingsModal';
import { ParticipantBehaviourStatusTag } from './ParticipantBehaviourStatusTag';

interface Props {
  participantId: string;
  participantBehaviour: ParticipantBehaviour;
  isDisabled?: boolean;
}

export const ParticipantBehaviourCard = (props: Props) => {
  const { participantId, participantBehaviour, isDisabled } = props;

  return (
    <ChakraV3.Card.Root w='full' h='full'>
      <ChakraV3.Card.Header>
        <ChakraV3.Stack>
          <ChakraV3.HStack align='stretch'>
            <ChakraV3.Stack gap={0}>
              <ChakraV3.Heading size='2xl' fontWeight='bold' lineClamp={1}>
                {participantBehaviour.name}
              </ChakraV3.Heading>
            </ChakraV3.Stack>
            <ChakraV3.Spacer />
            <ParticipantBehaviourActionMenu
              participantId={participantId}
              participantBehaviour={participantBehaviour}
              isDisabled={isDisabled}
            />
          </ChakraV3.HStack>
          <ParticipantBehaviourStatusTag status={participantBehaviour.status} w='fit-content' />
        </ChakraV3.Stack>
      </ChakraV3.Card.Header>

      <ChakraV3.Card.Body>
        <ChakraV3.Stack gap={4} h='full'>
          <ParticipantBehaviourDataSummary participantBehaviour={participantBehaviour} />
          <ChakraV3.Spacer />
          <ChakraV3.HStack w='full'>
            <ChakraV3.Button
              onClick={() =>
                showModal(ParticipantBehaviourRecordingsModal, {
                  participantId,
                  participantBehaviour,
                })
              }
              size='sm'
              flex={1}
              variant='subtle'
            >
              <FaEye />
              View recordings
            </ChakraV3.Button>
            <ParticipantBehaviourRecordingCreateButton
              participantBehaviours={[participantBehaviour]}
              participantId={participantId}
              disabled={isDisabled || isBehaviourDisabled(participantBehaviour.status)}
              flex={1}
            >
              Add recording
            </ParticipantBehaviourRecordingCreateButton>
          </ChakraV3.HStack>
        </ChakraV3.Stack>
      </ChakraV3.Card.Body>
    </ChakraV3.Card.Root>
  );
};
